<template>
  <div class="main-container" v-if="pageContent">
    <v-row>
      <v-col cols="12" md="2"> </v-col>
      <v-col cols="12" md="10">
        <div class="sub-title">
          {{ pageContent.subTitle }}
        </div>
        <div class="main-title">
          {{ pageContent.title }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar"> </v-col>
      <v-col cols="12" md="10">
        <div class="text-content">
          {{ pageContent.section_1 }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2"></v-col>
      <v-col cols="12" md="10">
        <div class="center-button">
          <router-link to="/dashboard">
            <img :src="`${imgLocation}icon_dashboard.png`" />
          </router-link>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <div class="separator">
          <img :src="`${imgLocation}MRA_plus-stip_slice1.svg`" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar"> </v-col>
      <v-col cols="12" md="10">
        <div class="text-content">
          {{ pageContent.section_2 }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar">
        <div class="section-label">Analyse per deelregio</div>
      </v-col>
      <v-col cols="12" md="10">
        <div
          class="inline-button"
          v-for="regio in deelregios"
          :key="regio.name"
        >
          <router-link :to="`/analyse/deelregio/${regio.name}`">
            <img :src="`${imgLocation}${regio.icon}`" />
          </router-link>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <div class="separator">
          <img :src="`${imgLocation}MRA_plus-stip_slice2.svg`" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar">
        <div class="section-label">Analyse per deelsector</div>
      </v-col>
      <v-col cols="12" md="10">
        <div
          class="inline-button"
          v-for="sector in deelsectoren"
          :key="sector.name"
        >
          <router-link :to="`/analyse/deelsector/${sector.name}`">
            <img :src="`${imgLocation}${sector.icon}`" />
          </router-link>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar"> </v-col>
      <v-col cols="12" md="10">
        <div class="content-title">
          <a :href="justificationDocUrl" target="_blank"
            >Verantwoording indicatoren (PDF)</a
          >
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" class="sidebar"> </v-col>
      <v-col cols="12" md="10" class="sidebar">
        <div class="colofon">
          {{ pageContent.colofon }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { json } from "d3-fetch";
export default {
  name: "Home",
  data: () => ({
    pageContent: null,
    deelregios: [
      { name: "MRA", icon: "icon_MRA.png" },
      { name: "Almere-Lelystad", icon: "icon_Almere.png" },
      { name: "Amstelland-Meerlanden", icon: "icon_Amstelland-Meer.png" },
      { name: "Amsterdam", icon: "icon_Amsterdam.png" },
      { name: "Gooi en Vechtstreek", icon: "icon_Gooi.png" },
      { name: "IJmond", icon: "icon_IJmond.png" },
      { name: "Zaanstreek-Waterland", icon: "icon_Zaanstreek.png" },
      { name: "Zuid-Kennemerland", icon: "icon_Kennemerland.png" }
    ],
    deelsectoren: [
      { name: "Beeldende kunst", icon: "icon_beeldende_kunst.png" },
      { name: "Erfgoed", icon: "icon_erfgoed.png" },
      { name: "Film", icon: "icon_film.png" },
      { name: "Letteren", icon: "icon_letteren.png" },
      { name: "Podiumkunsten", icon: "icon_podiumkunsten.png" }
    ]
  }),
  mounted() {
    json(`${process.env.VUE_APP_DATA_DIR}data/analyses/Startpagina.json`).then(
      data => {
        this.pageContent = data;
      }
    );
  },
  computed: {
    imgLocation() {
      return process.env.VUE_APP_DATA_DIR + "img/";
    },
    justificationDocUrl() {
      return `${process.env.VUE_APP_DATA_DIR}data/${process.env.VUE_APP_VERANTWOORDING_DOC}`;
    }
  }
};
</script>

<style lang="css" scoped>
.main-title {
  font-family: "Zilla Slab", serif;
  font-size: 3em;
  font-weight: bold;
  color: #ec0000;
}
.sub-title {
  font-family: "Avenir Medium", "Avenir";
  font-size: 2em;
}
.sidebar {
  background-color: #eeeeee;
}
.center-button {
  text-align: center;
  margin: 20px;
}
.inline-button {
  display: inline-block;
  margin: 20px 0px;
}
.separator {
  /* text-align: center; */
}
.section-label {
  font-weight: bold;
  font-size: 1.2em;
  margin: 5px;
}
.colofon {
  font-style: italic;
  margin-bottom: 40px;
}
.content-title {
  font-weight: bold;
}
</style>
